import types from '../mutation-types';
import DisparosAPI from '../../api/disparos';

export const state = {
  campaigns: [],
  contactLists: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUploading: false,
  },
};

export const getters = {
  getUIFlags: _state => _state.uiFlags,
  getCampaigns: _state => _state.campaigns,
  getContactLists: _state => _state.contactLists,
  getCampaignById: _state => id =>
    _state.campaigns.find(c => c.id === Number(id)),
};

export const actions = {
  fetchCampaigns: async ({ commit }) => {
    commit(types.SET_DISPAROS_UI_FLAG, { isFetching: true });
    try {
      const { data } = await DisparosAPI.getCampaigns();
      commit(types.SET_DISPARO_CAMPAIGNS, data);
    } catch (error) {
      // ignore
    } finally {
      commit(types.SET_DISPAROS_UI_FLAG, { isFetching: false });
    }
  },

  createCampaign: async ({ commit }, payload) => {
    commit(types.SET_DISPAROS_UI_FLAG, { isCreating: true });
    try {
      const { data } = await DisparosAPI.createCampaign(payload);
      commit(types.ADD_DISPARO_CAMPAIGN, data);
      return data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_DISPAROS_UI_FLAG, { isCreating: false });
    }
  },

  deleteCampaign: async ({ commit }, id) => {
    try {
      await DisparosAPI.deleteCampaign(id);
      commit(types.DELETE_DISPARO_CAMPAIGN, id);
    } catch (error) {
      throw new Error(error);
    }
  },

  updateCampaignInStore: ({ commit }, campaign) => {
    commit(types.EDIT_DISPARO_CAMPAIGN, campaign);
  },

  fetchContactLists: async ({ commit }) => {
    try {
      const { data } = await DisparosAPI.getContactLists();
      commit(types.SET_DISPARO_CONTACT_LISTS, data);
    } catch (error) {
      // ignore
    }
  },

  uploadContactList: async ({ commit }, formData) => {
    commit(types.SET_DISPAROS_UI_FLAG, { isUploading: true });
    try {
      const { data } = await DisparosAPI.uploadContactList(formData);
      commit(types.ADD_DISPARO_CONTACT_LIST, data);
      return data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_DISPAROS_UI_FLAG, { isUploading: false });
    }
  },

  deleteContactList: async ({ commit }, id) => {
    try {
      await DisparosAPI.deleteContactList(id);
      commit(types.DELETE_DISPARO_CONTACT_LIST, id);
    } catch (error) {
      throw new Error(error);
    }
  },
};

export const mutations = {
  [types.SET_DISPAROS_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.SET_DISPARO_CAMPAIGNS](_state, data) {
    _state.campaigns = data;
  },
  [types.ADD_DISPARO_CAMPAIGN](_state, data) {
    _state.campaigns.unshift(data);
  },
  [types.EDIT_DISPARO_CAMPAIGN](_state, data) {
    const idx = _state.campaigns.findIndex(c => c.id === data.id);
    if (idx !== -1) _state.campaigns.splice(idx, 1, data);
  },
  [types.DELETE_DISPARO_CAMPAIGN](_state, id) {
    _state.campaigns = _state.campaigns.filter(c => c.id !== id);
  },
  [types.SET_DISPARO_CONTACT_LISTS](_state, data) {
    _state.contactLists = data;
  },
  [types.ADD_DISPARO_CONTACT_LIST](_state, data) {
    _state.contactLists.unshift(data);
  },
  [types.DELETE_DISPARO_CONTACT_LIST](_state, id) {
    _state.contactLists = _state.contactLists.filter(c => c.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
